(function () {
  function initialize() {
    var description = document.querySelector('.template-product [data-cro-description]');
    var crossSell = document.querySelector('.template-product [id*="__frequently_bought_app_block"]');
    if (!description || !crossSell) return;

    var origin = document.createComment('Original description position');
    description.before(origin);
    var wrapper = document.createElement('div');
    wrapper.className = 'tabing vwd-mobile-description';
    var content = document.createElement('div');
    content.className = 'tab-content';
    wrapper.appendChild(content);
    var mobile = window.matchMedia('(max-width: 749px)');

    function positionDescription() {
      if (mobile.matches) {
        crossSell.before(wrapper);
        content.appendChild(description);
      } else {
        origin.after(description);
        wrapper.remove();
      }
    }

    positionDescription();
    mobile.addEventListener('change', positionDescription);
  }

  // Preserve the theme's tab and accordion handlers before moving the same node.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initialize, 0); });
  } else {
    setTimeout(initialize, 0);
  }
})();
